/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Typography from '../../../base/Typography';

// Handles header AND pagination styles
export const TypographyStyled = styled(Typography)`
 

  ${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let paddingBottom = rem(24);

    if (mediumUp) {
      paddingBottom = rem(40);
    }
    return css`
    color: ${theme.colors.neutral.white};
    text-align: center;
    padding-bottom: ${paddingBottom};
  `;
  }
}
`;

export const DivPaginationContainerStyled = styled.div`
  ${({ theme }) => {
    const xlargeUp = theme.useMediaQuery(theme.breakpoints.up('xlarge'));
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let top = 12;
    let right = 5;
    let paddingRight = 0;

    if (mediumUp) {
      top = 26;
    }

    if (xlargeUp) {
      paddingRight = 25;
      right = 0;
    } else if (mediumUp) {
      right = 20;
    }

    return css`
      position: absolute;
      right: ${rem(right)};
      top: ${rem(top)};
      padding-right: ${rem(paddingRight)};
    `;
  }}
`;

